import { DeleteIcon, EditIcon, InfiniteTable } from '@/components/_common';
import {
  useRecommendations,
  useRemoveRecommendation,
} from '@/core/domain/people/Recommendation/Recommendation.hooks';
import { Recommendation } from '@/core/domain/people/Recommendation/Recommendation.types';
import { useDisclosure } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Divider, Modal, Space } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import RecommendationModal from '../RecommendationModal';

export default function RecommendationList() {
  const intl = useIntl();

  const [recommendationId, setRecommendationId] = useState<number>();
  const [modalEditRecommendationOpened, modalEditRecommendationActions] =
    useDisclosure();

  const {
    data: recommendationsData,
    isFetching,
    fetchNextPage,
    hasNextPage,
  } = useRecommendations();

  const recommendations = flatInfiniteData(recommendationsData);
  const removeMutation = useRemoveRecommendation();

  const handleRemoveRecommendation = async (recommendationId: number) => {
    Modal.confirm({
      title: intl.formatMessage({
        id: 'customers.recommendation.notifications.remove.confirm.title',
      }),
      content: intl.formatMessage({
        id: 'customers.recommendation.notifications.remove.confirm.content',
      }),
      onOk: async () => {
        await removeMutation.mutateAsync(recommendationId);
      },
      okType: 'danger',
    });
  };

  const columns: ColumnsType<Recommendation> = [
    {
      dataIndex: 'description',
      key: 'description',
      title: intl.formatMessage({ id: 'customers.list.recommendation' }),
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: 'actions',
      key: 'actions',
      title: intl.formatMessage({ id: 'customers.list.header.actions' }),
      render: (value, record) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setRecommendationId(record.id);
                modalEditRecommendationActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveRecommendation(record.id)} />
        </Space>
      ),
      ellipsis: true,
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <InfiniteTable
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={recommendations}
        loading={isFetching}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
      />

      <RecommendationModal
        open={modalEditRecommendationOpened}
        onCancel={() => {
          setRecommendationId(undefined);
          modalEditRecommendationActions.close();
        }}
        recommendationId={recommendationId}
      />
    </>
  );
}
